import wordmarkInkDot from "@assets/clarik-wordmark-ink-dot_1779992771228.png";
import wordmarkPaperDot from "@assets/clarik-wordmark-paper-dot_1779992771228.png";

/**
 * Shared Clarik wordmark — see docs/brand-guidelines.md.
 * Light mode: clarik-wordmark-ink-dot · Dark mode: clarik-wordmark-paper-dot
 * Use className to set font-size context; image height scales at 1.1em.
 * dotColor is accepted for backward compat but ignored — the dot is baked into the image.
 */
interface ClarikMarkProps {
  className?: string;
  dotColor?: string;
}

export function ClarikMark({ className = "" }: ClarikMarkProps) {
  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src={wordmarkInkDot}
        alt="Clarik"
        className="h-[1.1em] w-auto dark:hidden"
        data-testid="clarik-mark-light"
      />
      <img
        src={wordmarkPaperDot}
        alt="Clarik"
        className="h-[1.1em] w-auto hidden dark:block"
        data-testid="clarik-mark-dark"
      />
    </span>
  );
}
